import {
  NoData,
  RenderWhen,
  ThreatStatusLabel
} from "../../../../../../components";
import { formatCount } from "../../../../../../components/PageResultsCount";
import styles from "../analysis-card.module.scss";

type Props = {
  malicious: number;
  total: number;
};

const NetworkReferencesValue = ({ malicious, total }: Props) => (
  <div className={styles.list_item_value}>
    <span className="flex align-center">
      <RenderWhen condition={!!total} fallback={<NoData />}>
        <ThreatStatusLabel
          labelText={`${formatCount(malicious ?? 0)}/${formatCount(
            total ?? 0
          )} Malicious`}
          threatStatus={malicious ? "malicious" : "unknown"}
          showTitle={false}
          showOrb={false}
          showColor
        />
      </RenderWhen>
    </span>
  </div>
);

export default NetworkReferencesValue;
